const API_BASE = process.env.REACT_APP_API_BASE || "";

export async function fetchArticles() {
  const res = await fetch(`${API_BASE}/api/articles`);
  if (!res.ok) throw new Error("Failed to fetch articles");
  return res.json();
}
